import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateProjectPayload,
  IDeleteProjectsPayload,
  IFetchProjectsPayload,
  IUpdateProjectsPayload,
  IUpdateProjectTitlePayload,
  ICreateClipsPayload,
  IStartBulkExportationPayload,
  IFetchProjectSharingPayload,
  IUpdateProjectSharingPayload,
  IUpdateBulkProjectSharingPayload,
} from './types'

function getConfig(): AxiosRequestConfig {
  return {
    responseType: 'json'
  }
}

export function fetchProjects(payload: IFetchProjectsPayload) {
  return axios.get('/api/v1/projects', { params: convertToSnakeCase(payload) })
}

export function updateProjects(payload: IUpdateProjectsPayload) {
  return axios.post('/api/v1/projects/updates', convertToSnakeCase(payload), getConfig())
}

export function deleteProjects(payload: IDeleteProjectsPayload) {
  return axios.delete(`/api/v1/projects/`,  { ...getConfig(), data: convertToSnakeCase(payload) })
}

export function deleteProjectsOnPageHide(payload: IDeleteProjectsPayload): Promise<Response> {
  return window.fetch('/api/v1/projects/', {
    method: 'DELETE',
    body: JSON.stringify(convertToSnakeCase(payload)),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.Checksub.token,
    },
    keepalive: true,
  })
}

export function createProject(payload: ICreateProjectPayload) {
  return axios.post(`/api/v1/projects/`, convertToSnakeCase(payload), getConfig())
}

export function updateProjectTitle(payload: IUpdateProjectTitlePayload) {
  return axios.put(`/api/v1/projects/${payload.projectId}/update_title`, convertToSnakeCase(payload), getConfig())
}

export function createClips(payload: ICreateClipsPayload) {
  return axios.post(`/api/v1/projects/${payload.projectId}/create_clips`, convertToSnakeCase(payload, ['translation_settings']), getConfig())
}

export function startBulkExportation(payload: IStartBulkExportationPayload) {
  return axios.post('/api/v1/projects/start_bulk_exportation', convertToSnakeCase(payload), getConfig())
}

export function fetchProjectSharing(payload: IFetchProjectSharingPayload) {
  return axios.get(`/api/v1/projects/${payload.projectId}/sharing`, getConfig())
}

export function updateProjectSharing(payload: IUpdateProjectSharingPayload) {
  return axios.put(`/api/v1/projects/${payload.projectId}/sharing`, convertToSnakeCase(payload), getConfig())
}

export function updateBulkProjectSharing(payload: IUpdateBulkProjectSharingPayload) {
  return axios.put('/api/v1/projects/bulk_sharing', convertToSnakeCase(payload), getConfig())
}
